import React from "react";
import styled, { keyframes } from "styled-components";
import Image from "../Atoms/Image";
import person_icon from "../../images/icon-person.png";

interface Testimonial {
  id: string;
  image?: string;
  title: string;
  description: string;
}

interface TestimonialCardProps {
  testimonials: Testimonial[];
}

const electric = keyframes`
  0% {
    background-position: 0% 50%;
  }
  100% {
    background-position: 200% 50%;
  }
`;

const ElectricCard = styled.div`
  position: relative;
  border-radius: 1rem;
  padding: 3px; /* grosor del borde */
  min-height: 280px;

  &::before {
    content: "";
    position: absolute;
    inset: 0;
    border-radius: inherit;

    background: linear-gradient(45deg, #4AB658, #00FFA0, #2E944B);

    background-size: 200% 200%;
    filter: blur(8px);
    animation: ${electric} 3s linear infinite;
    z-index: 0;
  }
`;

const CardInner = styled.div`
  position: relative;
  z-index: 1;
  height: 100%;

  border-radius: 0.9rem;
  background: #111827;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  padding: 0rem 1.5rem;
  text-align: center;
`;

const TestimonialCard: React.FC<TestimonialCardProps> = ({ testimonials }) => {
  return (
    <div className="w-full max-w-[80rem] mx-auto">
      <div className="flex flex-wrap justify-center">
        {testimonials.map((testimonial) => (
          <div
            className="p-4 w-[90%] sm:w-1/3 flex justify-center"
            key={testimonial.id}
          >
            <ElectricCard className="w-full max-w-xs sm:max-w-sm lg:max-w-md">
              <CardInner className="px-6 py-10 text-center relative">
                <Image
                  alt="testimonial"
                  className="w-20 mx-auto mb-4"
                  source={testimonial.image || person_icon}
                />

                <h1 className="text-lg font-medium text-white mb-3 break-words">
                  {testimonial.title}
                </h1>

                <p className={`text-white/80 break-words `}>
                  {testimonial.description}
                </p>
              </CardInner>
            </ElectricCard>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TestimonialCard;
